<div>
  （モーダルのヘッダ部分のHTML）<button class="button-test" id="testIdClose" (click)="close()">モーダルを閉じる</button>
</div>
